/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTicketRequest } from '../models/CreateTicketRequest';
import type { ExportFormat } from '../models/ExportFormat';
import type { GetTicketResponse } from '../models/GetTicketResponse';
import type { ListTicketsResponse } from '../models/ListTicketsResponse';
import type { ListTicketTypesResponse } from '../models/ListTicketTypesResponse';
import type { SortDirection } from '../models/SortDirection';
import type { TicketDepartment } from '../models/TicketDepartment';
import type { TicketSortBy } from '../models/TicketSortBy';
import type { TicketStatus } from '../models/TicketStatus';
import type { UpdateTicketRequest } from '../models/UpdateTicketRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TicketsService {
  /**
   * List tickets, filtering by various criteria.
   * @param query
   * @param status
   * @param department
   * @param createdAt
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @param format
   * @returns ListTicketsResponse OK
   * @throws ApiError
   */
  public static listTickets(
    query?: string,
    status?: Array<TicketStatus>,
    department?: Array<TicketDepartment>,
    createdAt?: string,
    limit?: number,
    offset?: number,
    sortBy?: TicketSortBy,
    sortDirection?: SortDirection,
    format?: ExportFormat,
  ): CancelablePromise<ListTicketsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Tickets',
      query: {
        'query': query,
        'status': status,
        'department': department,
        'createdAt': createdAt,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
        'format': format,
      },
    });
  }
  /**
   * Create a new ticket.
   * @param requestBody
   * @returns GetTicketResponse Created
   * @throws ApiError
   */
  public static createTicket(
    requestBody?: CreateTicketRequest,
  ): CancelablePromise<GetTicketResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Tickets',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * Get a single ticket by its id.
   * @param id
   * @returns GetTicketResponse OK
   * @throws ApiError
   */
  public static getTicket(
    id: string,
  ): CancelablePromise<GetTicketResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Tickets/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * Update a ticket by its id.
   * @param id
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static updateTicket(
    id: string,
    requestBody?: UpdateTicketRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Tickets/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * List all ticket types.
   * @param department
   * @returns ListTicketTypesResponse OK
   * @throws ApiError
   */
  public static listTicketTypes(
    department?: TicketDepartment,
  ): CancelablePromise<ListTicketTypesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Tickets/types',
      query: {
        'department': department,
      },
    });
  }
}
